import type { TranslationMessages } from '../../types';

export const shift_switching: TranslationMessages = {
  title: 'Shift Switching',
  subtitle:
    'Request and manage your shift exchanges with other staff members',
  live_updates: 'Live Updates',
  offline: 'Offline',
  tab_my_requests: 'My Requests',
  tab_received_requests: 'Received Requests',
  tab_available_shifts: 'Available Shifts',
  create_request: 'Create Request',
  my_requests_title: 'My Shift Switch Requests',
  my_requests_description:
    "Requests you've made to switch shifts with other staff members",
  received_requests_title: 'Received Shift Switch Requests',
  received_requests_description:
    'Requests from other staff members to switch shifts with you',
  available_shifts_title: 'Available Shifts for Switching',
  available_shifts_description:
    'Shifts that are available for switching with other staff members',
  loading_requests: 'Loading your requests...',
  loading_received: 'Loading received requests...',
  loading_shifts: 'Loading available shifts...',
  no_requests: 'No shift switch requests found',
  no_received: 'No received requests found',
  no_available_shifts: 'No available shifts for switching',
  request_card_title: 'Shift Switch Request',
  your_shift: 'Your Shift',
  requested_shift: 'Requested Shift',
  target_shift: 'Target Shift',
  from: 'From:',
  to: 'To:',
  reason: 'Reason:',
  accept: 'Accept',
  reject: 'Reject',
  cancel_request: 'Cancel Request',
  status_pending: 'Pending',
  status_accepted: 'Accepted',
  status_rejected: 'Rejected',
  status_cancelled: 'Cancelled',
  unassigned: 'Unassigned',
  failed_load_requests: 'Failed to load your shift switch requests',
  error_load_requests: 'Error loading your shift switch requests',
  failed_load_received: 'Failed to load received shift switch requests',
  error_load_received: 'Error loading received shift switch requests',
  failed_load_shifts: 'Failed to load your shifts',
  error_load_shifts: 'Error loading your shifts',
  failed_load_available: 'Failed to load available shifts',
  error_load_available: 'Error loading available shifts',
  failed_load_staff: 'Failed to load staff members',
  error_load_staff: 'Error loading staff members',
  accept_success: 'Shift switch request accepted successfully!',
  accept_failed: 'Failed to accept request',
  accept_error: 'Error accepting shift switch request',
  reject_success: 'Shift switch request rejected',
  reject_failed: 'Failed to reject request',
  reject_error: 'Error rejecting shift switch request',
  cancel_success: 'Shift switch request cancelled',
  cancel_failed: 'Failed to cancel request',
  cancel_error: 'Error cancelling shift switch request',
  create_success: 'Shift switch request created successfully!',
  create_failed: 'Failed to create request',
  create_error: 'Error creating shift switch request',
  form_title: 'Create Shift Switch Request',
  form_select_your_shift: 'Select Your Shift',
  form_select_your_shift_desc: 'Choose the shift you want to switch from',
  form_select_target_shift: 'Select Target Shift',
  form_select_target_shift_desc: 'Choose the shift you want to switch to',
  form_select_target_staff: 'Select Target Staff',
  form_select_target_staff_desc: 'Choose who you want to switch with (optional)',
  form_review: 'Review Request',
  form_review_desc: 'Confirm your shift switch request',
  form_no_shifts: 'No shifts available for switching',
  form_no_available: 'No available shifts for switching',
  form_open_request: 'Open Request',
  form_open_request_desc: 'Anyone can claim this shift',
  form_reason_label: 'Reason (Optional)',
  form_reason_placeholder: 'Why do you want to switch shifts?',
  form_select_both: 'Please select both shifts',
  form_creating: 'Creating...',
  form_create_request: 'Create Request',
  form_next: 'Next',
  form_back: 'Back',
  form_cancel: 'Cancel',
};
